export default __webpack_public_path__ + "static/media/image.thuru.88c22d74.png";